import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["list", "item", "input", "dropdown"];

    connect() {
        this.selectedIndex = 0;
        this.addHoverListeners();
        this.addOutsideClickListener();
    }

    showDropdown() {
        this.dropdownTarget.classList.remove("hidden");
        this.selectedIndex = 0;
        this.updateSelection();
        this.addHoverListeners();
    }

    filterDropdown(event) {
        const query = this.inputTarget.value.trim().toLowerCase();
        const dropdown = this.dropdownTarget;

        dropdown.classList.remove("hidden");

        if (query.length > 0) {
            this.filterItems(query);
            this.selectedIndex = 0; // Reset to the first item
            this.updateSelection(); // Update selection to the first item
        } else {
            const items = dropdown.querySelectorAll("li");
            items.forEach((item) => item.classList.remove("hidden")); // Unhide all items
            this.selectedIndex = 0; // Reset selection index
        }
        this.addHoverListeners(); // Update hover listeners
    }

    filterItems(query) {
        const items = this.dropdownTarget.querySelectorAll("li");
        items.forEach((item) => {
            const text = item.textContent.trim().toLowerCase();
            if (text.includes(query)) {
                item.classList.remove("hidden");
            } else {
                item.classList.add("hidden");
            }
        });
    }

    navigateDropdown(event) {
        const items = Array.from(this.dropdownTarget.querySelectorAll("li:not(.hidden)"));
        if (items.length === 0) return;

        switch (event.key) {
            case "ArrowDown":
                event.preventDefault();
                if (this.selectedIndex < items.length - 1) {
                    this.selectedIndex += 1; // Move down only if it's not the last item
                }
                this.updateSelection(); // Update selection
                break;
            case "ArrowUp":
                event.preventDefault();
                if (this.selectedIndex > 0) {
                    this.selectedIndex -= 1; // Move up only if it's not the first item
                }
                this.updateSelection(); // Update selection
                break;
            case "Enter":
                if (this.selectedIndex >= 0) {
                    event.preventDefault();
                    this.selectItem(items[this.selectedIndex]);
                }
                break;
            default:
                break;
        }
    }

    updateSelection() {
        const items = Array.from(this.dropdownTarget.querySelectorAll("li:not(.hidden)"));
        items.forEach((item, index) => {
            if (index === this.selectedIndex) {
                item.classList.add("bg-blue-100");
                item.scrollIntoView({block: "nearest"});
            } else {
                item.classList.remove("bg-blue-100");
            }
        });
    }

    selectItem(item) {
        const url = item.dataset.url;
        const queryParams = item.dataset.queryParams
        this.confirmAndFetch(url, queryParams)
    }

    addHoverListeners() {
        const items = this.dropdownTarget.querySelectorAll("li:not(.hidden)");
        items.forEach((item) => {
            item.addEventListener("mousemove", () => {
                this.clearActiveState();
                item.classList.add("bg-blue-100"); // Add active state to hovered item
                this.selectedIndex = Array.from(items).indexOf(item);
            });
        });
    }

    clearActiveState() {
        const items = this.dropdownTarget.querySelectorAll("li");
        items.forEach((item) => {
            item.classList.remove("bg-blue-100"); // Remove active state from all items
        });
    }

    addOutsideClickListener() {
        document.addEventListener("click", (event) => {
            if (!this.element.contains(event.target)) {
                this.dropdownTarget.classList.add("hidden");
            }
        });
    }

    handleClick(event) {
        const url = event.currentTarget.dataset.url;
        const queryParams = event.currentTarget.dataset.queryParams
        this.confirmAndFetch(url, queryParams)
    }

    confirmAndFetch(url, queryParams) {
        const confirmed = window.confirm("Are you sure you want to create this filter?");
        if (!confirmed) {
            return;
        }
        const params = queryParams ? JSON.parse(queryParams) : {};
        this.dropdownTarget.classList.add("hidden")

        const token = document.querySelector('meta[name="csrf-token"]').content
        fetch(url, {
            method: "POST",
            credentials: 'same-origin',
            headers: {
                'X-CSRF-Token': token,
                "Accept": "text/vnd.turbo-stream.html",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params)
        })
            .then(response => response.text())
            .then(html => {
                Turbo.renderStreamMessage(html)
            })
    }

}
